import React from 'react';
import { Eyebrow } from './ui';

const events = [
  {
    id: 1,
    name: 'Wöchentliches Vereinstreffen für Mitglieder',
    date: 'Jeden Mittwoch',
    description: 'Wöchentliches Treffen für Vereinsmitglieder.',
    location: 'Flugplatz Bad Langensalza (EDEB)',
  },
];

// Mobil eigene Sektion, am Desktop linke Spalte neben dem Kontakt (Layout in HomePage)
const Events: React.FC = () => {
  return (
    <section id="veranstaltungen" className="px-5 py-10 lg:p-0">
      <Eyebrow>Veranstaltungen</Eyebrow>
      <h2 className="mb-3 text-[32px] font-extrabold leading-[1.05] tracking-[-0.02em] lg:text-[40px] lg:leading-none lg:tracking-[-0.025em]">
        Unsere Events
      </h2>
      <p className="mb-5 text-base leading-normal text-gray-600 lg:mb-6">
        Besuchen Sie unsere Veranstaltungen und werden Sie Teil unserer Community!
      </p>

      <ul className="border-t-2 border-gray-900">
        {events.map((event) => (
          <li key={event.id} className="grid gap-2 pt-4 lg:grid-cols-[140px_1fr] lg:gap-x-5 lg:pt-[18px]">
            <span className="w-max self-start bg-blue-50 px-2.5 py-1 text-[13px] font-semibold text-blue-700 lg:text-sm">{event.date}</span>
            <div>
              <h3 className="text-xl font-extrabold tracking-[-0.01em]">{event.name}</h3>
              <p className="mb-2 mt-1 text-sm text-gray-500">{event.location}</p>
              <p className="text-[15px] leading-normal text-gray-600">{event.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Events;
